// extracted by mini-css-extract-plugin
module.exports = {"overlayMenu":"homeDropdown_overlayMenu__3_8SI"};